import { Control, Controller } from 'react-hook-form';
import { ErrorComponent } from './ErrorComponent';
import { IForm } from '../NewRequestPopUp';
import {
  DropdownStyle,
  VacationTypeContainer,
  VacationTypeLabel,
} from './styles/VacationTypeController.styled';
import { ErrorrContainer } from './styles/ErrorComponent.styled';
import { ResponsiveMode } from '@fluentui/react';

interface VacationTypeControllerProps {
  control: Control<IForm>;
  mappedVacationTypes: {
    key: string;
    text: string;
  }[];
}

export const VacationTypeController = ({
  control,
  mappedVacationTypes,
}: VacationTypeControllerProps) => {
  return (
    <Controller
      name="vacationType"
      control={control}
      render={({
        field: { onChange, onBlur, value },
        fieldState: { error },
      }) => (
        <VacationTypeContainer>
          <VacationTypeLabel htmlFor="vacationType">
            Vacation type <span className="required">*</span>
          </VacationTypeLabel>
          <DropdownStyle
            id="vacationType"
            placeholder="Please select an option"
            options={mappedVacationTypes}
            onChange={(_, option) => {
              if (option) {
                onChange(option.key);
              }
            }}
            onBlur={onBlur}
            selectedKey={value}
            responsiveMode={ResponsiveMode.large}
          />
          <ErrorrContainer>
            <ErrorComponent error={error} />
          </ErrorrContainer>
        </VacationTypeContainer>
      )}
    />
  );
};
